export type BackpackChip = { text: string; belongsInPrompt: boolean; conceptId: string };
export type BackpackRound = { goal: string; chips: BackpackChip[] };

const A = "adaptive_core";
const Y = "your_content";
const S = "self_hosted";
const O = "open_no_lockin";
const M = "measured_proof";

export const NOTANY_BACKPACK_DECK: readonly BackpackRound[] = [
  {
    goal: "Pack what you actually need to launch an internal training on notanyai.",
    chips: [
      { text: "Your own SubjectPack (your content).", belongsInPrompt: true, conceptId: Y },
      { text: "The adaptive engine.", belongsInPrompt: true, conceptId: A },
      { text: "Your own cloud account or VPC.", belongsInPrompt: true, conceptId: S },
      { text: "A per-seat SaaS license.", belongsInPrompt: false, conceptId: O },
      { text: "A deal to send your data to a third party.", belongsInPrompt: false, conceptId: S },
    ],
  },
  {
    goal: "List what proves competence at the end of a course.",
    chips: [
      { text: "Per-concept mastery for each person.", belongsInPrompt: true, conceptId: M },
      { text: "An auditable record you can query.", belongsInPrompt: true, conceptId: M },
      { text: "Evidence that survives an audit.", belongsInPrompt: true, conceptId: M },
      { text: "A count of how many videos played.", belongsInPrompt: false, conceptId: M },
    ],
  },
  {
    goal: "Decide what goes into the adaptive selection score.",
    chips: [
      { text: "Each learner’s Elo rating.", belongsInPrompt: true, conceptId: A },
      {
        text: "Curriculum-graph centrality (PageRank, betweenness).",
        belongsInPrompt: true,
        conceptId: A,
      },
      {
        text: "Per-concept mastery, propagated along the graph.",
        belongsInPrompt: true,
        conceptId: A,
      },
      { text: "A coin flip.", belongsInPrompt: false, conceptId: A },
    ],
  },
  {
    goal: "Choose the subjects a company could ship on the same engine.",
    chips: [
      { text: "Security and compliance drills.", belongsInPrompt: true, conceptId: Y },
      { text: "New-hire onboarding.", belongsInPrompt: true, conceptId: Y },
      { text: "Product knowledge for support teams.", belongsInPrompt: true, conceptId: Y },
      { text: "Only the AI-literacy course, nothing else.", belongsInPrompt: false, conceptId: Y },
    ],
  },
  {
    goal: "Pack the pieces of a self-hosted deployment.",
    chips: [
      { text: "A static front-end bundle.", belongsInPrompt: true, conceptId: S },
      { text: "An open Supabase backend.", belongsInPrompt: true, conceptId: O },
      { text: "A single small VM.", belongsInPrompt: true, conceptId: O },
      { text: "A mandatory third-party data processor.", belongsInPrompt: false, conceptId: S },
    ],
  },
  {
    goal: "What keeps a learner coming back day after day?",
    chips: [
      { text: "A daily streak.", belongsInPrompt: true, conceptId: A },
      { text: "Mini-games beyond plain quizzes.", belongsInPrompt: true, conceptId: A },
      { text: "A quest path with clear next steps.", belongsInPrompt: true, conceptId: A },
      { text: "Pop-up ads between questions.", belongsInPrompt: false, conceptId: A },
    ],
  },
];
